import { MutationTree } from 'vuex';
import { EGoogleDocsMutation } from '@/google-docs/store/google-docs.constants';
import { IGoogleDocsState } from '@/google-docs/store/google-docs.types';
import { IDocument } from '@lib-shared/types/Document';

export const mutations: MutationTree<IGoogleDocsState> = {
  [EGoogleDocsMutation.SetImporting](state: IGoogleDocsState, importing: boolean) {
    state.importing = importing;
  },
  [EGoogleDocsMutation.SetImported](state: IGoogleDocsState, imported: boolean) {
    state.imported = imported;
  },
  [EGoogleDocsMutation.SetDocuments](state: IGoogleDocsState, documents: IDocument[]) {
    state.documents = documents;
  },
  [EGoogleDocsMutation.SetState](state: IGoogleDocsState, newState: IGoogleDocsState) {
    state.documents = newState.documents;
    state.importing = newState.importing;
    state.imported = newState.imported;
  },
};
